import { MessageBox, Loading } from 'element-ui'
import { getToken, getUserToken } from '@/utils/cookies'
import { asyncSave } from "@/api/publishOnline";
import secret from "@/utils/secret.js";
import constant from '@/api/constant'
import wx from "weixin-js-sdk"
import Vue from 'vue';
import {Toast} from 'vant';
Vue.use(Toast);
const utils = {
}
/** 消息提示方法 */
utils.msgAlert = function (type, msg) {
  MessageBox.alert(msg, '提示', {
    confirmButtonText: '确定',
    type: type,
    callback: action => {
    }
  })
}
/** 遮罩 */
utils.Loading = function (tipsMsg) {
  const loading = Loading.service({
    lock: true,
    text: tipsMsg,
    background: 'rgba(0, 0, 0, 0.7)'
  })
  return loading
}

/** 不为空的判断 */
utils.isNotEmpty = function (param) {
  var falg = false
  if (param !== '' && param !== undefined && param !== null) {
    falg = true
  }
  return falg
}

/** 拼接axios请求参数配置 */
utils.getAxiosOption = function (method, url, params, data) {
  var option = {
    method: method,
    url: url,
    params: params,
    data: data
  }
  return option
}

/** 手机号替换中间四位**** */
utils.phoneReplace = function (val) {
  if (val !== '' && val !== undefined && val !== null) {
    let reg = /^(.{3}).*(.{4})$/
    return val.replace(reg, '$1****$2')
  }
}
/**** 防抖  ****/
utils.debounce = function(fn, delay=100){
    if(this.timer) clearTimeout(this.timer) 
    this.timer = setTimeout(fn, delay);
},
/** 生成UUID */
utils.uuid = function () {
  var s = []
  var hexDigits = getUserToken() + getToken()
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}

/** 获取数组中的目标数据，数组格式 [{id: 1},{id: 2}] */
utils.getOptionItemInArray = function (arrayData, validField, validContent) {
  let targetObj = {}
  targetObj = arrayData.find((item) => {
    return item[validField] === validContent
  })
  return targetObj
}

/** 获取数组中目标数据索引 */
utils.getOptionIndexInArray = function (arrayData, validField, validContent) {
  let changeIndex = -1
  changeIndex = arrayData.findIndex((item, index) => {
    return item[validField] === validContent
  })
  return changeIndex
}

/** 移除数组中的目标数据 */
utils.reduceOptionItemInArray = function (arrayData, validField, validContent) {
  if (arrayData.length > 0) {
    for (let i = 0; i < arrayData.length; i++) {
      if (arrayData[i][validField] === validContent) {
        arrayData.splice(i, 1)
      }
    }
  }
}
/** 移除数组中元素 */
utils.reduceItemInArray = function (arrayData, validContent) {
  if (arrayData.length > 0) {
    for (let itemIndex in arrayData) {
      if (arrayData[itemIndex] === validContent) {
        arrayData.splice(itemIndex, 1)
      }
    }
  }
}

/** 生成随机数方法 */
utils.getRandomNum = (minNum, maxNum) => {
  let max = 800
  let min = 0
  if (maxNum) max = maxNum
  if (minNum) min = minNum
  return parseInt(Math.random() * (max - min + 1) + min, 10)
}

utils.getToReadUrlByCategory = (category, params,type) => {
  let readType = {
    onLineLS:'/service',
    onLineBS:'/readerPDF'
  }
  let readTypeH5 = {
    onLineLS:'/read_al',
    onLineBS:'/mreaderPDF'
  }
  console.log("rrrrrs", category, params,type)
  let toReadPath = constant.read_web_url
  if ((constant.pl_kec == category) || (constant.pl_sp == category) || (constant.pl_yp == category) || (constant.pl_ypk == category)) { //课程或者视频
    toReadPath += '/read_cl?resourceId=' + params.resourceId + '&type=' + category
  } else if ((constant.pl_sj == category)) { //试卷
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExamStart?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExam?resourceId=' + params.resourceId + '&type=' + category
    }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else if ((constant.pl_al == category)||(constant.pl_xxzl == category) || (constant.pl_szts == category)|| (constant.pl_ts == category)||constant.pl_gf == category||constant.pl_lxcbw == category||constant.pl_wz == category||constant.pl_ptzy == category) { //案例/图书/规范/连续出版物/文章/配套资源
    if(!type){
      Toast('阅读方式不存在！')
      return
    }
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += readTypeH5[type]+'?resourceId=' + params.resourceId + '&type=' + category
    } else {
      console.log("11111111133333", readType[type])
      toReadPath += readType[type]+'?resourceId=' + params.resourceId + '&type=' + category
    }
  }else if ((constant.pl_zlj == category) ) { //资料集
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    toReadPath += '/mCatalog?resourceId=' + params.resourceId + '&type=' + category
    }else{
    toReadPath += '/pcCatalog?resourceId=' + params.resourceId + '&type=' + category
    }
  } else if ((constant.pl_xt == category)) { //习题
    if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      toReadPath += '/mobiExercises?resourceId=' + params.resourceId + '&type=' + category
      }else{
      toReadPath += '/pcExercises?resourceId=' + params.resourceId + '&type=' + category
      }
    delete params["title"]
    params['masterId'] = 0, params['doPaperDate'] = 'doAgain', params['submitId'] = ''
  } else {
    toReadPath = ''
  }
  delete params["resourceId"]
  if (utils.isNotEmpty(toReadPath)) {
    for (let paramIndex in params) {
      toReadPath += '&' + paramIndex + '=' + params[paramIndex]
    }
  }
  return toReadPath
}
/**未登录的时候去登陆**/
utils.toLogin =  function(text,currentPageText,platform,appCode,fullPath) {
  var CBZX_PLATFORM_PATH =
    process.env.CBZX_PLATFORM_PATH + fullPath;
  var redirectUrl = secret.encryptionText(CBZX_PLATFORM_PATH);
  let login = () => {
    if (appCode == "sztsg") {
      if(platform == 'mweb'){
        window.location.href = process.env.JGSSO_WEB_URL + "/mobileLogin?redirectUrl=" + redirectUrl;
      }else{
        window.location.href = process.env.JGSSO_WEB_URL + "/login?redirectUrl=" + redirectUrl;
      }
    } else {
      if(platform == 'mweb'){
        window.location.href = process.env.SSO_WEB_URL + "/mobileLogin?redirectUrl=" + redirectUrl;
      }else{
        window.location.href = process.env.SSO_WEB_URL + "/login?redirectUrl=" + redirectUrl;
      }
    }
  };
  utils.asyncSave(
    appCode,
    window.location.origin + window.location.pathname,
    currentPageText,
    '未登录-'+text,
    window.sessionStorage.getItem("previousUrl"),
    platform,
    login
  );
}

utils.second_to_time = function(second_number){
          let str = new Date(second_number*1000).toJSON();
          return typeof str == 'string' ? str.substring(11,19) : '';
      }


/** 分享微信以及朋友圈 
 * 
 * data:获取的微信加签
 * shareData:分享配置参数
*/
utils.wexinShare = (data, shareData) => {
  let appId = data.appId;
  let timestamp = data.timestamp;
  let nonceStr = data.nonceStr;
  let signature = data.signature;
  wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。（测试记得关掉）
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名，见附录1
      jsApiList: [
              'updateAppMessageShareData',
              'updateTimelineShareData'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  });
  wx.checkJsApi({
      jsApiList: ['chooseImage', 'updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function(res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          console.log(res, 'checkJsApi')
      }
  });
  wx.ready(function() {
      // //分享到朋友圈”及“分享到QQ空间”
      wx.updateTimelineShareData({
          title: shareData.title, // 分享标题
          link: shareData.link + '&t=' + timestamp + '&Content=1', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl, // 分享图标
          success: function(res) {
              // 设置成功
              console.log("分享朋友圈成功返回的信息为:", res);
          }
      })

      //“分享给朋友”及“分享到QQ”
      wx.updateAppMessageShareData({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link + '&t=' + timestamp + '&Content=1', // 分享链接 该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl, // 分享图标
          success: function(res) {
              console.log("分享朋友成功返回的信息为:", res);;
          }
      })

  });
  wx.error(function(res) {
      // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      console.log('验证失败返回的信息:', res);
  });
}

// 七鱼客服
utils.qi_yu = class {
  constructor () {
    // this.init()
  }
  init () {
    return (function (w, d, n, a, j) {
      w[n] = w[n] || function () {
        (w[n].a = w[n].a || []).push(arguments)
      }
      j = d.createElement('script')
      j.async = true
      //需要企业Appkey
      j.src = 'https://qiyukf.com/script/044865c94981c048609d5c94c1ae9c6d.js?hidden=1'
      j.doneState = { loaded: true, complete: true};
      j.onload = function() {
          window.ysf('onready', function() {
              if (!window.ysf) { throw new Error('未执行qiyukf.init()方法') }
              typeof (window.ysf.open) === 'function' && window.ysf.open()
          });
          
  };
      d.body.appendChild(j)
    })(window, document, 'ysf')
  }
  open (isFirstClick) {
      if(isFirstClick){  //首次点击 等待文件加载完毕执行open方法
          this.isFirstClick = false
          this.init()
      }else{
          if (!window.ysf) { throw new Error('未执行qiyukf.init()方法') }
          typeof (window.ysf.open) === 'function' && window.ysf.open()
      }
  }
}

/** 添加用户访问日志 */
utils.asyncSave = function (appCode,url,name,buttonName,previousUrl,platform,callback) {
  asyncSave('',{
    "appCode": appCode,
    "url": url,
    "name": name,
    "buttonName": buttonName,
    "previousUrl" : previousUrl,
    "platform":platform
  }).then(res => {
    if(res.data.errorInfo){
      //callback存在 有需要再执行的内容
      if(callback){
        callback()
      }
    }
  });

   /**
     * @deprecated 处理 pdf url，使其不在浏览器打开
     * @param {string} url
     */
    utils.handlePdfLink = function (url,fileName){
      console.log('url,fileName',url,fileName)
      return fetch(url, {method: 'get',responseType: 'arraybuffer'}).then((res)=> {
          if (res.status !== 200) return res.json()
          return res.arrayBuffer()
      }).then((blobRes) => {
          // 生成 Blob 对象，设置 type 等信息
          const e = new Blob([blobRes], {type: 'application/octet-stream','Content-Disposition':'attachment'})
          // 将 Blob 对象转为 url
          const link = window.URL.createObjectURL(e)
          // 扩展名
          const extension_name = ((u,s)=>(s=u.split('.').pop(),/^[\w\d_]+$/i.test(s)?'.'+s:''))(url);
          // 下载
          let a = document.createElement('a');
          a.href = link;
          a.download = fileName?(fileName+extension_name):decodeURI(url.split('/')[url.split('/').length - 1]); //解码
          a.click();
          return true
      }).catch(() => { 
          return false
      })
  }
},
/** 判断当前设备 */
utils.currentDevice =  ()=>{
    // 获取屏幕宽度
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let os = function () {
        let ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
        isAndroid = /(?:Android)/.test(ua),
        isFireFox = /(?:Firefox)/.test(ua),
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || 
                  (isFireFox && /(?:Tablet)/.test(ua)) || (screenWidth >= 768 && screenWidth <= 1024),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian && !isTablet;
        return {
          isTablet: isTablet,
          isPhone: isPhone,
          isAndroid: isAndroid,
          isPc: isPc
        };
      }();
    
    console.log('os', os)
    if(os.isPc){
      console.log("---------1电脑",screenWidth);
      return 'pc'
    }else if(os.isTablet){
      console.log("---------1平板",screenWidth);
      return 'pad'
    }else{
      console.log("---------1移动",screenWidth);
      return 'mobile'
    }
}
 
export default utils



// WEBPACK FOOTER //
// ./src/utils/utils.js